module.exports = __webpack_public_path__ + "static/img/jikou.e2f005e4.png";